//Owl Carousel - Product

$('#owl-carousel-product').owlCarousel({
    items: 3,
	loop:true,
    margin:10,
    navigation: true,
  	center:true,
    dots:true,
	responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
});

//Owl Carousel - Ingredient
$(document).ready(function () {

$('#owl-carousel-ingredient').owlCarousel({
    items: 3,
	loop:true,
    margin:10,
    navigation:true,
    dots:true,
	responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:3
        }
    }
});
});

/*let owl_nav = document.querySelectorAll(".owl-nav");
console.log(owl_nav);
for(let i=0; i<owl_nav.length; i++){
    owl_nav[j].classList.remove("disabled");                         
}*/
//let play = document.querySelector(".play-button");
  //console.log(play);
//let video_div = document.querySelector(".video-div");
  //console.log(video_div);
 // video_div.removeAttribute("controls");
//video_div.style.pointerEvents = "none";
//play.addEventListener("click",() => {
  //console.log("play");
		//video_div.play();
//video_div.setAttribute("controls","");
  //})
  

/* Menu - coles redirect*/

/*let menuClass = document.querySelectorAll(".main-nav__tier-1-link,.dropdown-nav a,.footer-top__block-menu a,.mobile-menu-link a");

for(let i=0; i<menuClass.length; i++){
  let menuLink = menuClass[i].getAttribute("href");
    if(menuLink == "https://shop.coles.com.au/a/national/everything/search/people%20haircare?pageNumber=1")
    {
        menuClass[i].setAttribute("target","_blank");

    }
}*/

//Tips & Tricks

let width_screen = screen.width;
  //console.log(width_screen);

  var details = document.querySelectorAll(".details-common");
  for (let i = 0; i < details.length; i++) {
	details[i].addEventListener("click",() => {
                                removeAllClasses();
     details[i].classList.add("active-tab");  
  	});  
  }
function removeAllClasses(){
   let nav_item = document.querySelectorAll(".details-common");
   for(let j=0; j<nav_item.length; j++) {
      nav_item[j].classList.remove("active-tab");
   }
}
function detailsAndTips(tabName) {
if( width_screen < 767){
  console.log("success");
  var details = document.getElementsByClassName("details-tips");
  //console.log(details);
  for (let i = 0; i < details.length; i++) {
    details[i].style.display = "none";  
  }
  document.getElementById(tabName).style.display = "block";  
}
}

$('#owl-carousel-video').owlCarousel({
    items: 1,
	loop:true,
    margin:10,
    navigation: true,
    dots:true
});  

$(document).ready(function () {
var vid = document.getElementById("Mp4Video-template--15974063538400__1651290315b89e144c");
vid.addEventListener("timeupdate", myFunction);

function myFunction() {
  document.querySelector(".hero__text-wrap").style.display = "none";  
}
});

/* Menu - coles redirect*/

let menuClass = document.querySelectorAll(".site-nav__link,.footer__collapsible ul li a,.mobile-nav__link");

for(let i=0; i<menuClass.length; i++){
  let menuLink = menuClass[i].getAttribute("href");
    //if(menuLink == "https://shop.coles.com.au/a/national/home?cid=cdc:top-nav:shop-online")
    if(menuLink == "https://shop.coles.com.au/a/national/home?cid=cdc:top-nav:shop-online" || menuLink == "https://shop.coles.com.au/a/cessnock/everything/search/kings%20domain%20melbourne?pageNumber=1")
    {
        menuClass[i].setAttribute("target","_blank");

    }
}
if($('.section-about-story').length > 0) {
  $('#HeaderWrapper').addClass('is-light');
  $(window).on('scroll', function(){
    __scrolltop = $(this).scrollTop();
    if(__scrolltop > 100) {
      $('#HeaderWrapper').removeClass('is-light');
    }else {
      $('#HeaderWrapper').addClass('is-light');
    }
  });
}